import { PartnerComingSoonView } from "@/components/partner/PartnerViews";
import { usePartnerPageMeta } from "@/components/partner/PartnerWorkspaceShell";

type Props = {
  title: string;
  description: string;
};

const PartnerPlaceholder = ({ title, description }: Props) => {
  usePartnerPageMeta({ title, subtitle: description });
  return <PartnerComingSoonView title={title} description={description} />;
};

export default PartnerPlaceholder;
